import axios from "axios";
import { auth, authReady } from "../../lib/firebase";

const baseUrl = process.env.REACT_APP_API_URL;

// Employees sign in via Okta and never get a Firebase session, so
// axiosInstance (Firebase-only) would send no Authorization header for
// them. Resolve the token the same way loginToken does — Firebase user
// first, Okta access token otherwise — but freshly on every request.
async function authHeaders() {
    await authReady;
    const user = auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        return { Authorization: `Bearer ${token}` };
    }
    try {
        const oktaStorage = JSON.parse(localStorage.getItem("okta-token-storage"));
        const oktaToken = oktaStorage?.accessToken?.accessToken;
        return oktaToken ? { Authorization: `Bearer ${oktaToken}` } : {};
    } catch {
        return {};
    }
}

export async function getOrganizations() {
    const { data } = await axios.get(`${baseUrl}/hq/organizations`, {
        headers: await authHeaders(),
    });
    return data.organizations || [];
}

export async function getOrgUsers(orgId) {
    const { data } = await axios.get(`${baseUrl}/hq/users`, {
        params: { orgId },
        headers: await authHeaders(),
    });
    return data.usersList || [];
}

export async function bulkCreateUsers(payload) {
    const { data } = await axios.post(`${baseUrl}/hq/users/bulk`, payload, {
        headers: await authHeaders(),
    });
    return data;
}

export async function resetUserPassword(uid) {
    const { data } = await axios.post(
        `${baseUrl}/hq/users/${uid}/reset-password`,
        null,
        { headers: await authHeaders() }
    );
    return data;
}

export const ROLE_OPTIONS = [
    { value: "admin", label: "Admin" },
    { value: "marketing", label: "Marketing" },
    { value: "compliance", label: "Compliance" },
    { value: "baseUser", label: "Base User" },
];

export const roleLabels = ROLE_OPTIONS.reduce((acc, r) => {
    acc[r.value] = r.label;
    return acc;
}, {});

export async function copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        // Clipboard API needs a secure context; fall back to execCommand.
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy");
            return true;
        } catch {
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}
